import React from "react";

/**
 * Единый заголовок секции страницы: mono-eyebrow + optional actions.
 * Убирает разнобой section-паттернов между 5 табами.
 */
export function Section({
  title,
  subtitle,
  actions,
  children,
  testId,
}: {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  testId?: string;
}) {
  return (
    <section data-testid={testId} className="space-y-2">
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 px-0.5">
          <div className="min-w-0">
            {title && (
              <h3 className="text-[11px] font-mono font-bold uppercase tracking-[0.18em] text-fg-muted">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs text-fg-secondary mt-0.5">{subtitle}</p>
            )}
          </div>
          {actions && <div className="shrink-0">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
